import { createStyles } from 'antd-style';
import { colors } from '../../styles/colors';

const useStyles = createStyles(({ token }) => {
  return {
    'session-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '30px',
    },
    'session-client-selector': {
      width: '250px',
    },
    'session--input': {
      width: '80%',
      marginBottom: '20px',
    },
    'session--tabs-row': {
      position: 'relative',
    },
    'session--draggable-events': {
      'right': '0',
      'top': '0',
      'display': 'flex',
      'flexDirection': 'row',
      'flexWrap': 'wrap',

      '@media (min-width: 611px)': {
        position: 'absolute',
      },
    },
    'session--draggable-events__hint': {
      alignSelf: 'center',
      marginRight: '15px',
      fontSize: '24px',
      color: colors['--triad-blue-1'],
    },
    'session--buttons-container': {
      display: 'flex',
      maxWidth: '250px',
      width: '200px',
      justifyContent: 'space-between',
    },
    'session--image-title': {
      margin: '20px 0',
    },
    'session--title': {
      marginBottom: '20px',
      textAlign: 'center',
    },
    'session--tooltip': {
      minWidth: '50%',
    },
    'diagnosis--tag': {
      whiteSpace: 'pre-wrap',
      padding: '5px',
    },
    'sessions--mental-status': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    'sessions--mental-status__s': {
      width: '200px',
      maxWidth: '200px',
      marginRight: '20px',
    },
    'sessions--data-column--s': {
      width: '200px',
      maxWidth: '200px',
      marginRight: '20px',
    },
    'sessions--data-column--m': {
      width: '250px',
      maxWidth: '250px',
      marginRight: '20px',
    },
    'sessions--data-column--l': {
      width: '290px',
      maxWidth: '290px',
      marginRight: '20px',
    },
    'sessions--data-column--xl': {
      width: '340px',
      maxWidth: '340px',
      marginRight: '20px',
    },
    'sessions--data-column--xxl': {
      width: '370px',
      maxWidth: '370px',
      marginRight: '20px',
    },
    'sessions--data-column--xxxl': {
      width: '400px',
      maxWidth: '400px',
      marginRight: '20px',
    },
    'sessions--data-column--xxxxl': {
      width: '450px',
      maxWidth: '450px',
      marginRight: '20px',
    },
    'sessions--data-column--max': {
      width: '100%',
      maxWidth: '100%',
      marginRight: '20px',
    },
    'cc-quill-editor': {
      'ul[data-checked="true"]': {
        'li::before': {
          content: '"✓"',
          fontSize: '1.5rem',
        },

        'li': {
          textDecoration: 'line-through',
        },
      },
      'ul[data-checked="false"]': {
        'li::before': {
          content: "'u2E3A'",
          fontSize: '1.5rem',
        },
      },
    },
    'sessions--vertical-column--s': {
      display: 'flex',
      flexDirection: 'column',
      width: '200px',
      maxWidth: '200px',
      marginRight: '20px',
      alignItems: 'baseline',
    },
    'sessions--vertical-column--m': {
      display: 'flex',
      flexDirection: 'column',
      width: '250px',
      maxWidth: '250px',
      marginRight: '20px',
      alignItems: 'baseline',
    },
    'note-title-container': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginBottom: '10px',
    },
    'save-pdf--button': {
      marginLeft: 'auto',
      marginRight: '20px',
    },
    'spin-container': {
      display: 'flex',
      justifyContent: 'center',
      margin: '20px 0',
    },
    'duration--content': {
      margin: '0 10px',
    },
    '.ant-select-customize-input': {
      height: 'auto',
    },
    '.ant-select-selector .ant-select-selection-item': {
      whiteSpace: 'normal',
      wordBreak: 'break-all',
    },

    'draggable-session': {
      'marginRight': '10px',
      '.ant-btn': {
        cursor: 'grab',
      },
    },
    'sessions--delete-warn-icon': {
      fontSize: '20px',
      color: colors['--primary-1'],
    },
    'cc-fc-event-title': {
      'height': '100%',

      '@media (max-width: 800px)': {
        fontSize: '11px',
      },
    },
    'cc-sessoins-full-calendar': {
      '& .fc-button-primary': {
        backgroundColor: colors['--triad-blue-1'],
        borderColor: colors['--triad-blue-1'],
      },
      '& .fc-button-active': {
        'backgroundColor': `${colors['--triad-blue-3']} !important`,
        'borderColor': `${colors['--triad-blue-3']} !important`,
        '&:hover': {
          backgroundColor: `${colors['--triad-blue-4']} !important`,
          borderColor: `${colors['--triad-blue-4']} !important`,
        },
      },
      '& .fc-toolbar-title': {
        'margin': '0 5px',

        '@media (max-width: 500px)': {
          fontSize: '20px',
        },
        '@media (max-width: 460px)': {
          fontSize: '16px',
          textAlign: 'center',
        },
      },
    },
  };
});

export default useStyles;
